<form *ngIf="fields" [ngClass]="{'invalid-submit': invalidSubmit}" [formGroup]="addEditForm" (ngSubmit)="saveOrUpdate()" RestrictFocus>

  <div class="ui-grid ui-grid-responsive ui-fluid">

      <div class="ui-grid-row bottom-10-margin">
        <div class="ui-grid-col-4">
          <label [ngClass]="{'required': !fields.name.nullable}">{{ fields.name.keyName }}</label>
        </div>
        <div class="ui-grid-col-8">
          <input type="text" formControlName="name" pInputText [maxlength]="fields.name.width"/>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm" [validation]="fields.name"></app-validation-msg>
        </div>
      </div>

      <div class="ui-grid-row bottom-10-margin">
        <div class="ui-grid-col-4">
          <label [ngClass]="{'required': !fields.parent_id.nullable}">{{ fields.parent_id.keyName }}</label>
        </div>
        <div class="ui-grid-col-8">
          <p-dropdown
            [style]="{'width':'100%'}"
            formControlName="parent_id"
            [options]="classifications_items">
          </p-dropdown>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm" [validation]="fields.parent_id"></app-validation-msg>
        </div>
      </div>

      <div class="ui-grid-row bottom-10-margin">
        <div class="ui-grid-col-4">
          <label [ngClass]="{'required': !fields.classification_type_id.nullable}">{{ fields.classification_type_id.keyName }}</label>
        </div>
        <div class="ui-grid-col-8">
          <p-dropdown
            [style]="{'width':'100%'}"
            formControlName="classification_type_id"
            [options]="classification_types"
            (onChange)="onClTypeChange($event)">
          </p-dropdown>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm" [validation]="fields.classification_type_id"></app-validation-msg>
        </div>
      </div>

  </div>

  <p-footer>
    <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix" style="display: flex; justify-content: center; border: 0; margin-top: 15px;">
          <button class="k-generic-btn" type="submit" pButton icon="fa fa-check" [label]="editingElement.id ? ('common.edit' | translate) : ('common.add' | translate)"></button>
      </div>
  </p-footer>

</form>



// WEBPACK FOOTER //
// ./src/app/views/classification/classification-list/classification-form.component.html